module.exports = __webpack_public_path__ + "static/media/burger.81ae961a.png";